import * as d3 from 'd3-format';
import formatBytes from './formatBytes';

/**
 Remove trailing insignificant zeroes from a numeric string.
 @param {String} str - The numeric string.
 @return ${String} The string with trailing insignificant zeroes removed.
 **/
function removeTrailing(str) {
  if (str.includes('.')) {
    while (str.endsWith('0')) {
      str = str.substring(0, str.length - 1); // eslint-disable-line no-param-reassign
    }
    if (str.endsWith('.')) {
      return str.substring(0, str.length - 1);
    }
  }
  return str;
}

/**
 Format a value.
 @param {NumberWidget|String} value - The value to be formatted.
 @param {String} [format='.3s'] - The format specifier for values where
 Math.abs(value) >= 1. Please see d3-format for available options. Two
 additional types are supported:
 'b' - Decimal notation with a decimal byte multiple prefix (KB, MB, ...).
 'B' - Decimal notation with a binary byte multiple prefix (KiB, MiB, ...).
 @param {String} [smallFormat='.2f'] - The format specifier for values where
 0 < Math.abs(value) < 1.
 **/
function formatValue(value, format = '.3s', smallFormat = '.2f') {
  if (value === null || value === undefined || value === '' || Number.isNaN(value)) {
    return '';
  }
  const asFloat = parseFloat(value);
  const specifier = d3.formatSpecifier(format);
  let formatted;

  if (Number.isNaN(asFloat)) {
    formatted = '';
  } else if (Math.abs(asFloat) > 0 && Math.abs(asFloat) < 1) {
    formatted = d3.format(smallFormat)(asFloat);
  } else if (specifier.type === 'b') {
    formatted = formatBytes(value, specifier.precision, false);
  } else if (specifier.type === 'B') {
    formatted = formatBytes(value, specifier.precision, true);
  } else {
    formatted = d3.format(format)(asFloat);
  }

  // Remove trailing zeroes.
  return removeTrailing(formatted);
}

export default formatValue;
